// @flow
import React, { Fragment } from "react";
import { Box, Button, Input, Toast } from "biologiatotal-ui";
import styled from "styled-components";
import "./planCoupon.scss";
import PlanBox from "../planBox";
import Icon from "../../../components/icon";
import * as Dimmer from "../../../components/dimmer";
import { getCurrencyFormat } from "../../../components/utils/currency";

type Props = {
  selectedPlan: any,
  coupon: any,
  onRemoveCoupon: any,
  onApplyCoupon: any,
  onCouponCodeChange: any,
  isApplyingCoupon: any,
  plans: any,
  onSelectPlan: any,
  couponCode: any,
  isFetching: any
};

type State = {
  price: number
};

class PlanCoupon extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {
      price: 0
    };

    this.onPlanSelected = this.onPlanSelected.bind(this);
  }

  //TODO Fazer teste
  getDiscount(): number {
    const { selectedPlan, coupon } = this.props;

    switch (coupon.coupon.type) {
      case "total":
        return selectedPlan.price;
      case "discount":
        return Number(((selectedPlan.price * coupon.coupon.discount) / 100).toFixed(2));
      case "alternative_value":
        return Number((selectedPlan.price - coupon.coupon.alternative_value).toFixed(2));
      default:
        throw new Error("Cupom inválido");
    }
  }

  planSelector() {
    const { plans, selectedPlan } = this.props;

    return (
      <Fragment>
        <span className="pay-panel-title">ESCOLHA O PLANO</span>
        <span className="pay-panel-subtitle">Você terá acesso à toda a plataforma</span>

        <div className="pay-panel-plans">
          {plans.map(it => (
            <PlanBox key={it.title} plan={it} onSelect={this.onPlanSelected} selectedPlan={selectedPlan} />
          ))}
        </div>
      </Fragment>
    );
  }

  onPlanSelected(plan) {
    const { onRemoveCoupon, onSelectPlan, coupon } = this.props;
    const hasCoupon = !!coupon;

    onSelectPlan(plan).then(() => {
      const planDifferentFromCoupon = hasCoupon && plan.id !== coupon.plan.id;
      if (planDifferentFromCoupon) {
        Toast.warning(this.props.couponCode.warning);
        onRemoveCoupon(false);
      }
    });
  }

  componentDidUpdate(prevProps, prevState) {
    const currentPlan = this.props.selectedPlan || {};
    const currentCoupon = this.props.coupon || { plan: {} };
    const prevPlan = prevProps.selectedPlan || {};
    const prevCoupon = prevProps.coupon || { plan: {} };

    if (prevCoupon.plan.id !== currentCoupon.plan.id || prevPlan.id !== currentPlan.id) {
      this.updateCurrentPrice();
    }
  }

  updateCurrentPrice() {
    const { selectedPlan, coupon, setCurrentPrice } = this.props;

    const hasSelectedPlan = !!selectedPlan;
    const hasCoupon = !!coupon;
    let price = hasSelectedPlan ? selectedPlan.price : 0;
    let discount = 0;

    if (hasCoupon && hasSelectedPlan) {
      if (selectedPlan.id === coupon.plan.id) {
        discount = this.getDiscount();
        price = price - discount;
      }
    }

    this.setState({
      price: price
    });

    setCurrentPrice(price);
  }

  applyCoupon(code) {
    const { onApplyCoupon, onRemoveCoupon } = this.props;

    onApplyCoupon(code).catch(err => {
      if (err === 999) {
        Toast.warning(this.props.couponCode.warning);
        onRemoveCoupon(false);
      } else {
        Toast.error(
          <div>
            <b>O cupom inserido não é válido!</b>
            <br />
            Digite um cupom válido e tente novamente
          </div>
        );
      }
    });
  }

  render() {
    const {
      onRemoveCoupon,
      onCouponCodeChange,
      selectedPlan,
      coupon,
      couponCode,
      isApplyingCoupon,
      isFetching
    } = this.props;

    const hasSelectedPlan = !!selectedPlan;
    const hasCoupon = !!coupon;
    let price = hasSelectedPlan ? selectedPlan.price : 0;
    let discount = 0;

    if (hasCoupon && hasSelectedPlan) {
      if (selectedPlan.id === coupon.plan.id) {
        discount = this.getDiscount();
        price = price - discount;
      }
    }

    if (isFetching) {
      return <Loading />;
    }

    return (
      <Fragment>
        <div className="columns is-multiline pay-panel">
          <Box className="column centered pay-panel-content is-12-mobile is-8-tablet is-8-desktop is-6-widescreen is-offset-2-tablet is-offset-2-desktop is-offset-3-widescreen">
            {this.planSelector()}

            <div className="pay-panel-coupon field is-grouped">
              <div className="pay-panel-coupon-input column">
                <Input
                  disabled={hasCoupon ? "disabled" : ""}
                  type="text"
                  value={couponCode.value}
                  onChange={e => onCouponCodeChange(e.target.value)}
                  onKeyPress={e =>
                    e.key === "Enter" && !hasCoupon && couponCode.value ? this.applyCoupon(couponCode.value) : undefined
                  }
                  placeholder="Cupom de desconto"
                  className="pay-panel-input"
                />
              </div>
              <div>
                <Button
                  link
                  loading={isApplyingCoupon}
                  className="pay-panel-button"
                  onClick={() => {
                    if (hasCoupon) {
                      onRemoveCoupon(true);
                    } else {
                      this.applyCoupon(couponCode.value);
                    }
                  }}>
                  {hasCoupon ? "REMOVER" : "APLICAR"}
                </Button>
              </div>
            </div>
            {coupon && (
              <PayPanelDiscountWrapper>
                <PayPanelDiscount>
                  <Icon icon="tag" width={32} height={32} className="discount-tag-icon" />
                  <div className="discount-texts">
                    <span className="discount-label">Você economizou</span>
                    <span className="discount-value">
                      {`${getCurrencyFormat(discount, "R$ ", "0").replace(".", ",")}`}
                    </span>
                  </div>
                </PayPanelDiscount>
              </PayPanelDiscountWrapper>
            )}
            <div className="pay-panel-infos">
              <hr className="pay-panel-divider" />
              <span className="pay-panel-price">{`${getCurrencyFormat(price, "R$ ", "0").replace(".", ",")}`}</span>
              <span className="pay-panel-label">Valor total</span>
            </div>
          </Box>
        </div>
      </Fragment>
    );
  }
}

const PayPanelDiscountWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
`;

const PayPanelDiscount = styled.div`
  display: flex;
  justify-content: space-between;
  color: #bbbbbb;
  border: 1px dashed #bbbbbb;
  border-radius: 8px;
  padding: 8px 16px;
  margin-top: 24px;

  .discount-texts {
    display: flex;
    flex-direction: column;
  }

  .discount-label {
    font-size: 0.75rem;
    color: #bbbbbb;
  }

  .discount-value {
    font-size: 1.125rem;
    color: #44ba3a;
    font-weight: bold;
    line-height: 1.5rem;
  }
`;

const Loading = props => (
  <div className="columns is-multiline plancoupon-panel">
    <div className="column pay-plan centered is-4 is-offset-4">
      <Dimmer.Text />
      <Dimmer.Text />
      <Dimmer.Text />
    </div>
  </div>
);

PlanCoupon.displayName = "PlanCoupon";

export default PlanCoupon;
